export default __webpack_public_path__ + "static/media/55.bb7ebd2e.png";